// @flow

import React from 'react';
import cx from 'classnames';

type Props = {
  raw: string,
  className?: string,
};

const RawImage = ({ raw, className, alt }: Props) => {
  const imageClass = cx('ui image', className);

  return (
    <div className={imageClass} style={{ overflow: 'visible' }}>
      <img src={raw} crossOrigin="Anonymous" alt="Rendu" />
    </div>
  );
};

export default RawImage;



// WEBPACK FOOTER //
// ./src/shared/components/RawImage.js